<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center" v-if="administrador === true">
          <!-- Título -->
          <basic-toolbar :title="'Lista de Usuários-Proex'"></basic-toolbar>
          <v-card-title>
            <v-spacer></v-spacer>
            <!-- Filtro -->
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>
          <v-card-text>
            <!-- Tabela com a lista de Usuários-PROEX -->
            <v-data-table
            :headers="headers"
            :items="listaUsuariosProex"
            :search="search"
            :no-data-text="'Nenhum usuário encontrado'"
            must-sort
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <!-- Rodapé -->
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaUsuariosProex.length }} usuários
              </template>              
            </v-data-table>
            <v-card-actions>
              <v-btn color="primary" text @click="voltar">Voltar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import usuariosProex from '@/utils/usuariosProex'
  import { mapGetters, mapActions } from 'vuex'
  export default {
    data: () => ({
      listaUsuariosProex: [],
      search: null,
      itemsPerPage: -1,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Nome', align: 'left', value: 'nomeUsuario' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      voltar: function () {
        this.$router.push({name: 'Administracao'})
      },
      listarUsuariosProex () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando Usuários-Proex.' })
        usuariosProex.getUsuariosProex()
        .then(response => {
          this.listaUsuariosProex = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.listaUsuariosProex = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando Usuários-Proex.' })
        })
      }
    },
    mounted () {
      this.listarUsuariosProex()
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }
  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// usuarios-proex.vue?23fc9fd3